export enum LangEnum {
  'DEFAULT_LANG' = 'kh',
  'KH' = 'kh',
  'EN' = 'en',
}
